import { Reveal, SectionTag, SectionTitle, StatusBadge } from "./shared";

const INSIDE = [
  { name: "Gaur 16th Parkview", type: "Apartments", status: "Under Development" },
  { name: "Waterfront Plots", type: "Plots", status: "Operational" },
  { name: "Lakeshore Villas", type: "Villas", status: "Under Development" },
  { name: "City Galleria", type: "Retail", status: "Under Development" },
];

const AROUND = [
  { name: "ACE Group Developments", type: "Sector 22D - Residential", status: "Under Development" },
  { name: "Aerocity Yamuna", type: "Commercial - Gaur", status: "Announced" },
  { name: "YEIDA Institutional Sectors", type: "Sector 22E & beyond", status: "Under Development" },
  { name: "International Film City", type: "Sector 21 - YEIDA", status: "Announced" },
];

function ListCard({ title, tag, items, testId }) {
  return (
    <div className="border border-[#D4AF37]/15 bg-[#111111] rounded-[2px] p-7 lg:p-9" data-testid={testId}>
      <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-2">{tag}</p>
      <h3 className="font-serif-lux text-2xl text-[#F5F5F0] mb-6">{title}</h3>
      <ul className="space-y-4">
        {items.map((it) => (
          <li key={it.name} className="flex items-center justify-between gap-4 border-b border-[#D4AF37]/10 pb-4">
            <div>
              <p className="text-sm text-[#F5F5F0]">{it.name}</p>
              <p className="text-[11px] text-[#71717A] mt-0.5">{it.type}</p>
            </div>
            <StatusBadge status={it.status} />
          </li>
        ))}
      </ul>
    </div>
  );
}

export function AroundGYC() {
  return (
    <section className="relative py-28 lg:py-40 bg-[#0D0D0D]" data-testid="around-gyc-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTag>What&rsquo;s Happening Around GYC?</SectionTag>
        <div className="grid lg:grid-cols-2 gap-8 items-end mb-14">
          <SectionTitle>The Neighbourhood Is <span className="text-gold-gradient italic">Expanding.</span></SectionTitle>
          <Reveal delay={0.15}>
            <p className="text-sm text-[#A1A1AA] leading-relaxed max-w-md lg:ml-auto">
              Multiple major developers and development nodes - including the high-activity
              Sector 22D - are contributing to the formation of a larger residential and
              commercial ecosystem around the township.
            </p>
          </Reveal>
        </div>
        <div className="grid lg:grid-cols-2 gap-6">
          <Reveal delay={0.1}><ListCard title="Inside GYC" tag="Within the Township" items={INSIDE} testId="inside-gyc-list" /></Reveal>
          <Reveal delay={0.2}><ListCard title="Around GYC" tag="The Wider Corridor" items={AROUND} testId="around-gyc-list" /></Reveal>
        </div>
        <Reveal delay={0.25}>
          <p className="mt-8 text-[11px] text-[#71717A] leading-relaxed max-w-3xl" data-testid="around-gyc-disclaimer">
            Projects listed &ldquo;Around GYC&rdquo; are independent developments by their respective
            developers and are not part of Gaur Yamuna City. Verify each project&rsquo;s developer,
            approvals and RERA registration independently.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
